import { createTranslator } from '@werkdelta/shared';
import dict from '@werkdelta/shared/locales/de-CH.json';

/**
 * de-CH ist die einzige gelieferte Locale (Auftrag 13.3);
 * die Struktur erlaubt fr-CH als spätere Ergänzung.
 */
const translator = createTranslator(dict as Record<string, string>);

export const t = translator.t;
export const hasKey = translator.has;
